<template>
  <div class="card mb-2 border-info shadow-sm">
    <div
      class="card-header py-1 px-3 bg-light d-flex justify-content-between align-items-center"
      style="cursor: pointer;"
      @click="showExplicacion = !showExplicacion"
    >
      <span class="font-weight-bold text-dark" style="font-size: 13.5px;">
        <i class="bi bi-info-circle-fill text-info mr-2"></i>Significado de los Niveles de Atributos (Jerarquía)
      </span>
      <button type="button" class="btn btn-sm btn-link text-info p-0 font-weight-bold">
        <i :class="showExplicacion ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
        <small class="ml-1">{{ showExplicacion ? 'Ocultar' : 'Ver explicación' }}</small>
      </button>
    </div>
    <div v-show="showExplicacion" class="card-body py-2 px-3 bg-white" style="font-size: 13px;">
      <p class="text-muted mb-2">
        Los valores se determinan por jerarquía en cascada: el nivel más específico sobreescribe a los más generales.
      </p>
      <div class="row">
        <div class="col-md-6 col-lg mb-2">
          <span class="badge badge-primary px-2 py-1 mb-1">1. servicio</span>
          <p class="mb-0 text-dark small">
            <b>Nivel Servicio:</b> Prioridad máxima. Valor configurado puntualmente para este servicio. Sobrescribe Producto, Operador y Default.
          </p>
        </div>
        <div class="col-md-6 col-lg mb-2">
          <span class="badge badge-info px-2 py-1 mb-1">2. producto</span>
          <p class="mb-0 text-dark small">
            <b>Nivel Producto:</b> Aplica a todos los servicios de este producto. Sobrescribe Operador y Default, salvo que el servicio tenga su propio valor.
          </p>
        </div>
        <div class="col-md-6 col-lg mb-2">
          <span class="badge badge-warning px-2 py-1 mb-1 text-dark">3. operador</span>
          <p class="mb-0 text-dark small">
            <b>Nivel Operador:</b> Configurado a nivel telco/operador. Aplica si no está definido en Producto o Servicio. Sobrescribe Default.
          </p>
        </div>
        <div class="col-md-6 col-lg mb-2">
          <span class="badge badge-secondary px-2 py-1 mb-1">4. tipo_suscripcion</span>
          <p class="mb-0 text-dark small">
            <b>Nivel Modalidad:</b> Configurado según la periodicidad o tipo de suscripción. Aplica en caso de no existir niveles superiores.
          </p>
        </div>
        <div class="col-md-6 col-lg mb-2">
          <span class="badge badge-default-hierarchy bg-white text-dark border border-dark px-2 py-1 mb-1">5. default</span>
          <p class="mb-0 text-dark small">
            <b>Nivel Default:</b> Valor base general del catálogo. Se toma cuando ningún nivel superior tiene un valor específico asignado.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AtributosNivelesCard",
  data() {
    return {
      showExplicacion: false,
    };
  },
};
</script>

<style scoped>
.badge-default-hierarchy {
  background-color: #ffffff !important;
  color: #000000 !important;
  border: 1px solid #000000 !important;
}
</style>
